<ngx-loading [show]="isProcessing"></ngx-loading>


<app-container-middle [height]="80">

  <div class="row">
    <div class="col-md-12">
      <div class="box-header text-center">
        <h3 class="box-title">Tratar OS avaliada</h3>
      </div> 
    </div>
  </div>


<div class="row">
  <div class="col">
 

        <section *ngIf="this.resultadosPesquisa?.length > 0" class="animated fadeInDown mt-2 ">

            <div class="box-body">

              <div class="box-table h450">
              <table>
                <thead>

                
                  <th>OS</th>
                  <th>Serviço solicitado</th>
                  <th>Data hora emissão</th>
                  <th>Requisitante</th>
                  <th>Tipo OS</th>
                  <th>Origem</th>
                  <th>Área técnica</th>
                  <th>Prioridade</th>

                </thead>

              <tbody>
                <tr class="cp" 
                *ngFor="let item of this.resultadosPesquisa" 
                (click)="getById(item?.id, item?.spvId, modalDetalhesOS)"
                [ngClass]="{'row-yellow' : item?.qualificado == 3, 'row-blue' : item?.qualificado == 2}"
                >
                  
                  <td class="text-center">{{ item?.id | zerosEsquerda : 5 }}</td>
                  <td>{{item?.servicoSolicitado}}</td>
                  <td class="text-center">{{item?.dataHoraEmissao}}</td>
                  <td class="text-center">{{item?.requisitante}}</td>
                  <td class="text-center">{{item?.tipoOS}}</td>
                  <td class="text-center">{{item?.origem}}</td>
                  <td class="text-center">{{item?.areaTecnica}}</td>
                  <td class="text-center">{{item?.prioridade}}</td>
                </tr>
              </tbody>
            </table>

           </div>











             <!--  <app-grid-OSs [listaDeOSs]="this.resultadosPesquisa" [podeImprimir]="this.autorizacoes?.podeListar"
                [heightGridPx]=300 [modoEdicao]=this.autorizacaoEditarOS>
              </app-grid-OSs> -->
            </div>
          
        </section>

        <section *ngIf="this.resultadosPesquisa?.length ==  0 && nenhumResultado == true"
          class="animated fadeInDown h300 text-center" style="margin-top:70px;">

          <div class="row">
            <div class="col-md-12">
              <img src="./assets/images/no-result2.png">
            </div>
            <div class="col-md-12">
              <h6>Nenhuma OS para ser tratada</h6>
            </div>
          </div>
        </section>

      
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-md-4">

      <div class="box-table" style="border: none; overflow: hidden;">
      <table>
        <thead>
          <tr>
            <th style="background-color: white !important; border-color: white !important;">Legenda</th>
          </tr>
        </thead>
        <tbody>
        <tr class="row-yellow">
          <td>Avaliação efetuada</td>
        </tr>
        <tr class="row-blue">
          <td>Avaliação de serviço</td>
        </tr>
      </tbody>
      </table>
    </div>
    </div>
  </div>


</app-container-middle>

<app-detalhes-os 
  [parameters]="this.parameters" 
  (cancelarOS)="cancelarOSEmitter($event, modalAction)"
  (qualificarOS)="qualificarOSEmitter($event, modalAction)"
  [showRegistroFotografico]="false"
  [showMateriais]="false"
  [showIrregularidades]="false"
  [showDadosRealizacao]="false"
  [showButtonImprimirOSComEvidenciaFotos]="false"
  [showButtonImprimirOSSemEvidenciaFotos]="false"
  [showButtonLiberarOSParaExecucao]="true"
  [showButtonCancelarOS]="true"
  msgButtonFechar="Desistir"
></app-detalhes-os>


<ng-template #modalAction let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">SIGEM CLOUD</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex justify-content-center">
          <img src="assets\images\icon-question.png" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="alert alert-warning">
          <div class="text-center">
            <span class="question-modal pt-3 pb-3" [innerHTML]="this.msgQuestion"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Não</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2" (click)="actionModal(c)">Sim</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
